module.exports={
    "over_size_message":"A feltöltött kép több mint 10MB. A feltöltéshez tömörítjük a fájlt. A feltöltés folytatásához kattintson a „Megerősítés” gombra.",
    "file_type_error":"A feltöltött fájl nem kép! Kérjük, próbálja meg újra feltölteni.",
    "upload_error":"Feltöltési hiba! (Hibakód: 2000) Kérjük, próbálja újra.",
    "watermark_remove_over_size":"A feltöltött kép több mint 5MB. Javasoljuk, hogy használja az ingyenes online képkompresszorunkat. Kattintson a <a class=\"jump-link\" href=\"https://www.tipard.com/hu/image-compressor-online/\">további információért</a>.",
    "watermark_remove_file_type_error":"A feltöltött fájl nem kép, kérjük töltse fel újra.",
    "watermark_remove_image_type_error":"A képformátum nem támogatott. Csak a JPG, JPEG, PNG és BMP fájlokat támogatjuk.",
    "watermark_remove_upload_error":"Felismerési hiba (hibakód: 2001), próbálkozzon újra...",
    "watermark_remove_processing":"Kép feldolgozása...",
    "watermark_remove_not_save":"A kiválasztott terület nem marad meg. Biztosan le akarod vágni?",
    "watermark_remove_back_home":"A jelenlegi állapot nem kerül mentésre. Biztosan vissza akar térni a Kezdőlapra?",
    "watermark_remove_new_image":"A jelenlegi állapot nem kerül mentésre. Biztosan új képet szeretne választani?",
    "watermark_select":"Válassza ki",
    "watermark_select_area":"Mielőtt az Eltávolítás gombra kattintana, válassza ki a törölni kívánt vízjel területét.",
    "watermark_beyond_4k":"A kiválasztott kép felbontása meghaladja a 4K felbontást. Sajnáljuk, hogy jelenleg nem tudjuk feldolgozni",
    "watermark_beyond_pixel_1":"A kiválasztott képfelbontás meghaladja a <span>%spx</span><span>&times;%spx</span> értéket. Nem lehet feldolgozni, kérjük, válassza ki újra.",
    "watermark_beyond_pixel_2":"A látogatók csak <span>%s</span> képet dolgozhatnak fel <span>%spx</span>x<span>%spx</span> feletti felbontással. Kérjük, jelentkezzen be, és használja tovább.",
    "watermark_beyond_size_1":"A kiválasztott kép mérete meghaladja a <span>%sMB-ot</span>. Nem lehet feldolgozni, kérjük, válassza ki újra.",
    "watermark_beyond_size_2":"A kiválasztott kép mérete meghaladja a <span>%sMB</span>-t, de a látogatók csak <span>%sMB</span>-nál kisebb képeket tudnak feldolgozni. Kérjük, jelentkezzen be, és használja tovább.",
    "no_user_down":"A látogatók csak eredeti minőségben tölthetik le a(z) <span>%s</span> képeket. Kérjük, jelentkezzen be, és folytassa a letöltést. Ezenkívül megőrizheti a bejelentkezés utáni 7 napos előzményeket. Folytassa a <span>%spx</span> széles vagy magas képek letöltését.",
    "no_down_rights":"Nem lehet HD képeket eredeti minőségben letölteni, kérjük, frissítse tervét! Folytathatja az alacsony minőségű képek letöltését a <span>%spx</span> segítségével.",
    "error_40001":"Hiba: 40001. Kérjük, lépjen kapcsolatba velünk",
    "error_40099":"Hiba: 40099. Kérjük, lépjen kapcsolatba velünk",
    "down_btn":"A letöltés előkészítés alatt áll, várjon egy pillanatot...",
    "noRemove_down_btn":"Nem tett semmit a vízjelek eltávolításáért. Kérjük, válassza ki az eltávolítani kívánt vízjelet, és kattintson az Eltávolítás gombra. Ezután letöltheti a képet.",
    "history_open":"A módosított kép megnyitása, kérjük, várjon egy kicsit...",
    "maskRightsMonitor_info":"Az előnyök frissítésének oldala új lapon nyílt meg, és a csomag automatikusan szinkronizálva lesz a frissítés után.",
    "maskLoginMonitor_info":"A nyitóoldal megnyílt, kérjük, fejezze be rajta a bejelentkezést. Sikeres bejelentkezés vagy regisztráció után ez az oldal automatikusan szinkronizálva lesz, kérjük, ne zárja be.",
    "photo_rights_info":"Jelenleg <span><i class=\"num\">2</i> HD-kép</span> tölthető le eredeti minőségben. <a href=\"https://account.tipard.com\" target=\"_blank\">Részletek>></a>",
    "rights_original":"A \"A képjavító funkció használata a minőségromlás csökkentése érdekében\" beállítás bekapcsolásához frissítenie kell fiókját!",
    "Brush":"Kefe",
    "Lasso":"Lasszó",
    "Polygonal":"Sokszögű",
    "Eraser":"Radír",
    "Free":"Ingyenes",
    "More":"Több:",
    "Select":"Válassza ki",
    "Remove":"Távolítsa el",
    "BrushSize":"Kefeméret:",
    "AspectRatio":"Képarány:",
    "Upload":"Új kép",
    "History":"Történelem",
    "Login":"Belépés",
    "MyAccount":"Fiókom",
    "Logout":"Kijelentkezés",
    "Usinghelp":"Segítség használata >>",
    "Enhancer":"Használja az Image Enhancer funkciót a minőségromlás csökkentése érdekében",
    "Download":"Letöltés",
    "Guide":"Útmutató",
    "Polygonal1":"Sokszögű",
    "Polygonal_info":"Kattintson a bal egérgombbal egy pont azonosításához.",
    "Lasso1":"Lasszó:",
    "Lasso_info":"Nyomja meg hosszan a bal egérgombot a vízjel terület lasszózásához.",
    "Brush1":"Kefe:",
    "Brush_info":"Tartsa lenyomva a bal egérgombot a pontos kiválasztáshoz.",
    "Eraser1":"Radír:",
    "Eraser_info":"Törölje a felesleges részeket a kiválasztott területről.",
    "Click":"Kattintson",
    "the":"a",
    "click_info":"gombot a nem kívánt vízjel eltávolításához.",
    "PleaseUploadImages":"Kérjük, töltsön fel képeket.",
    "CropInfo":"A vízjel eltávolítása után kattintson a Vágás gombra a kép kivágásához a mentés előtt, vagy kattintson a Letöltés gombra az aktuális kép közvetlen mentéséhez.",
    "Crop":"Vág",
    "Back":"Vissza",
    "DownloadCropped":"Letöltés Levágva",
    "Cancel":"Megszünteti",
    "FreeWatermarkRemover":"Ingyenes vízjel eltávolító",
    "Processing":"Feldolgozás...",
    "NewImage":"Új kép",
    "Retry":"Próbálja újra",
    "Yes":"Igen",
    "No":"Nem",
    "FailureFeedback":"Visszajelzés hiba esetén",
    "removeTip":"A vízjelterület kiválasztása után kattintson az Eltávolítás gombra a vízjel törléséhez.",
    "rightDown":"Gyenge minőségű képek letöltése",
    "history_will":"után lejár",
    "Expired":"(Lejárt)",
	"uploadImage":"Kép hozzáadása",
    "uploadImageInfo":"Vagy dobja ide a képfájlt a vízjel eltávolításához!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Korlátlan",
    "watermark_beyond_pixel_3":"A kiválasztott kép meghaladja a <span>%s&time;%s felbontást</span>, kérjük, előbb frissítse tervét.",
    "watermark_beyond_size_3":"A kiválasztott kép nagyobb, mint <span>%sMB</span>. Kérjük, előbb frissítse tervét.",
    "no_user_login":"Az új felhasználók, akik bejelentkeznek, KÉT HD eredeti képletöltési előnyhöz juthatnak.<span class=\"loginMaskbtn\">Azonnal jelentkezzen be>></span>",
    "Upgrade":"Frissítés",
    "Loading":"Betöltés…",
    "SelectAll":"Mindet kiválaszt",
    "Open":"Nyisd ki",
    "Delete":"Töröl",
    "Clear":"Törölje az érvénytelen",
    "noHistory":"Nincs előzmény",
    "Close":"Bezárás",
    "buyUserInfo":"gratulálok! Sikeresen frissítetted. Kérjük, térjen vissza a kezdőlapra, és használja ezt a terméket.",
    "buyNoUserInfo":"Gratulálunk! Sikeresen frissítetted. Az előnyök a frissítés során megadott e-mail címhez lettek kötve. Kérjük, használja a regisztrált vagy az e-mail címhez kapcsolódó fiókot a <span class=\"loginMaskbtn\">bejelentkezéshez az előnyök használatához</span>. Ha nem regisztrált vagy nem kapcsolt össze fiókot az e-mail címmel, kérjük, <span class=\"registerMaskbtn\">használja az e-mail címet egy fiók regisztrálásához</span> vagy kapcsoljon össze más fiókokat ehhez az e-mail címhez. mail cím a juttatások igénybevételéhez.",
    "GetStarted":"Fogj neki",
    "AccessTo":"Hozzáférés:",
    "imagesOfwatermarkremoval":"képek a vízjel eltávolításáról",
    "upTo":"Akár",
    "perImage":"képenként",
    "Support":"Támogatás",
    "resolution":"felbontás",
    "PrepaidPackage":"Előre fizetett csomag",
    "PayasYouGo":"Fizetés menet közben",
    "TaxIncl":"Adóval együtt",
    "Checkout":"Pénztár",
    "imagesDay":"képek/nap",
    "imagesMonthly":"képek/havonta",
    "image":"kép",
    "images":"képeket",
    "imageSize":"képméret",
    "buyInfo1":"Harmadik féltől származó <span>javító</span> integrációk",
    "buyInfo2":"A szerkesztési előzmények 7 napig érvényesek",
    "buyInfo3":"Elsőbbségi feldolgozás",
    "buyInfo4":"7x24-es ügyfélszolgálat",
    "buyInfo5":"24 óra múlva lejárt",
    "buyInfo6":"Nincs előfizetés. Nincs automatikus megújítás!",
    "buyInfo7":"Bármikor, örökké használható",
    "dayPlan":"1 napos terv",
    "Lifetime":"Élettartam",
    "note":"<span>Megjegyzés</span>: Felhívjuk figyelmét, hogy a megvásárolt csomag a fizetéskor megadott e-mail címhez van kötve. A csomag sikeres használatához regisztráljon vagy jelentkezzen be ugyanazzal az e-mail címmel.",
    "buy_now": "Vásároljon most",
    
    "banner_title": "AI Photo Cleanup - ile chcesz",
    "banner_info": "1 Kredyt = 1 Zdjęcie: Kosztujesz 1 kredyt i zapisz obraz większy niż 600 × 600 pikseli. ",
    "monthlyPlan_title": "Plan miesięczny",
    "monthlyPlan_displayPricePerCredit": "/kredyt",
    "monthlyPlan_plan1_credits": "Kredyty/Mo.",
    "monthlyPlan_feature1": "<span> bez ryzyka: </pan> 30-dniowa gwarancja zwrotu pieniędzy",
    "monthlyPlan_feature2": "<pan> Automatyczne: </pan> Kredyty są odnawiane automatycznie",
    "monthlyPlan_feature3": "<span> elastyczne: </pan> obniżka, aktualizuj lub anuluj w dowolnym momencie",
    "oneTimePurchase_title": "Jednorazowy zakup",
    "oneTimePurchase_plan5_credits": "Kredyty/życie",
    "oneTimePurchase_feature1": "30-dniowa gwarancja zwrotu pieniędzy",
    "oneTimePurchase_feature2": "Na stałe ważne po zakupie",
    "payment_title": "Możesz wybrać wiele metod płatności",
    "payment_image_alt": "Metody płatności",
    "faq_title": "Często zadawane pytania dotyczące zakupu kredytów",
    "faq_question1_title": "Co to są kredyty?",
    "faq_question1_info": "Nasza usługa jest mierzona w jednostce kredytów. ",
    "faq_question2_title": "Czy powinienem wybrać miesięczną subskrypcję lub jednorazowy zakup?",
    "faq_question2_info": "W przypadku nieregularnych zadań obrazu lub rzadkiego wymogu użytkowania możesz wybrać jednorazowy zakup, w którym można kupić odpowiednią ilość kredytów na podstawie wymagań dotyczących wizerunku. ",
    "faq_question3_title": "Co jeśli użyję moich kredytów?",
    "faq_question3_info": "Możesz zaktualizować subskrypcję lub nadal kupować jednorazowy plan zakupu na podstawie potrzeb przetwarzania zdjęć. ",
    "faq_question4_title": "Czy mogę uaktualnić, obniżyć się lub anulować moją subskrypcję?",
    "faq_question4_info": "Tak, możesz. ",
    "whyChoose_title": "Dlaczego warto wybrać Tiparda",
    "whyChoose_reason1_title": "Bezpieczne pobieranie",
    "whyChoose_reason1_info": "Programy z Tipard są w 100% czyste i bezpieczne",
    "whyChoose_reason2_title": "Technologia profesjonalna",
    "whyChoose_reason2_info": "Wykwalifikowany zespół zapewnia profesjonalne produkty",
    "whyChoose_reason3_title": "Obsługa klienta 24/7",
    "whyChoose_reason3_info": "Usługi konsultantów pacjentów przez cały czas",
    "whyChoose_reason4_title": "30 dni pieniędzy",
    "whyChoose_reason4_info": "Gwarancja zwrotu użytkownikom za 30 dni",
    "whyChoose_reason5_title": "1 000 000 użytkowników",
    "whyChoose_reason5_info": "Używane i zaufane przez ponad 1 milion ludzi",
    "whyChoose_reason6_title": "Ponad 160 krajów",
    "whyChoose_reason6_info": "Sprzedawane w ponad 160 krajach i regionach"
}